import { useCallback, useEffect, useRef, useState } from "react";
const useLoading = (callLocks, initialState = true)=>{
    const [isLoading, setLoading] = useState(initialState);
    const callLocksRef = useRef(callLocks);
    useEffect(()=>{
        callLocksRef.current = callLocks;
    }, [
        callLocks
    ]);
    const updateLoading = useCallback(()=>{
        for (const callLock of callLocksRef.current){
            if (callLock.current) {
                setLoading(true);
                return;
            }
        }
        setLoading(false);
    }, []);
    const doFetchLoading = useCallback(async (callLock, fetchFnc, onError, retriesOptions)=>{
        if (callLock.current) return;
        callLock.current = true;
        setTimeout(updateLoading, 300);
        const doFetch = async ()=>await fetchFnc().catch(async (error)=>{
                if (retriesOptions?.maxRetries && retriesOptions?.retriesLock && retriesOptions.retriesLock.current < retriesOptions.maxRetries - 1) {
                    retriesOptions.retriesLock.current++;
                    return await doFetch();
                } else if (onError) {
                    return await onError(error);
                } else {
                    console.error(error);
                }
            });
        const result = await doFetch();
        callLock.current = false;
        updateLoading();
        return result;
    }, [
        updateLoading
    ]);
    return {
        isLoading,
        updateLoading,
        doFetchLoading
    };
};
export default useLoading;

//# sourceMappingURL=useLoading.js.map